const getToastNotification = state => state.toastReducer;

export const getToastSeverity = state => getToastNotification(state).severity;
export const getToastTitle = state => getToastNotification(state).toastTitle;
export const getShouldShowToast = state => getToastNotification(state).shouldShowToast